import { render, staticRenderFns } from "./GruppoEdit.vue?vue&type=template&id=3c6cd806&scoped=true&"
import script from "./GruppoEdit.vue?vue&type=script&lang=js&"
export * from "./GruppoEdit.vue?vue&type=script&lang=js&"
import style0 from "./GruppoEdit.vue?vue&type=style&index=0&id=3c6cd806&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6cd806",
  null
  
)

export default component.exports